export default "__VITE_ASSET__04e2bc23__"